// Copyright (c) Docugami, Inc. All rights reserved.

import { NotificationModel } from "networking/NotificationsApi";
import { NotificationsManagerSingleton } from "notifications/NotificationsManager";
import { useOrganizationDataRequest } from "./OrganizationDataRequest";

/**
 * Fetches the global list of notifications
 */
export function useFetchNotifications(autoFetch: boolean) {
    return useOrganizationDataRequest<NotificationModel[]>(
        "Fetch Notifications",
        autoFetch,
        () => NotificationsManagerSingleton.notifications,
        (orgId) => NotificationsManagerSingleton.fetchNotifications(orgId),
        () => !NotificationsManagerSingleton.requests.fetchNotifications.lastRequestTime);
}
